import type { Policy as PolicyModel } from '@/adapters/catalogv1.g';

export function extractPolicy(model: PolicyModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.policy_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    policyType: model.policy_type,
    state: model.state,
    priority: model.priority,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogPolicy = ReturnType<typeof extractPolicy>;
